module.exports = __webpack_public_path__ + "images/chameleon_icon_white.svg";